import { productBaseFields, variantsAll, FULL_PRODUCT_FIELDS } from './fragments/productFields';

const getProductById = (id, country) => `
  ${country ? `query @inContext(country: ${country})` : 'query'} {
    product(id: "gid://shopify/Product/${id}") {
    ${productBaseFields({
        warningKey: 'product_warning',
        includeImages: true,
        imageCount: 200,
        includeCollections: true,
        collectionsCount: 50,
        includeTags: true,
    })}
      media(first: 200) {
        edges {
          node {
            mediaContentType
            ... on Video { id sources { url mimeType format height width } }
          }
        }
      }
      options(first: 24) { name }
    ${variantsAll({ shape: 'nodes', first: 50 })}
      relatedProduct: metafield(namespace: "custom", key: "related_products_override") {
        value
        references(first: 10) {
          nodes {
            ... on Product {
              ${FULL_PRODUCT_FIELDS({ variantShape: 'nodes', variantFirst: 50, imageCount: 50 })}
            }
          }
        }
      }
    }
  }
`;

export default getProductById;
